import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ICasesService } from "services/CasesService";
import { SETTING_TYPES } from "services/userSettings/SettingTypes";
import { IUserSettingsService } from "services/UserSettingsService";
import { CaseModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";

const initialState = {
  Cases: new Array<CaseModel>(),
  SavedColumnOrder: Array<string>(),
  LoadingCases: false,
  CaseTypeID: -1,
  CaseStatusTypeID: -1,
  SLAType: -1,
};

export const casesTableSlice = createSlice({
  name: "cases",
  initialState,
  reducers: {
    setCaseTypeID: (state, action) => {
      state.CaseTypeID = action.payload;
    },
    setCaseStatusTypeID: (state, action) => {
      state.CaseStatusTypeID = action.payload;
    },
    setSLAType: (state, action) => {
      state.SLAType = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCases.pending, (state) => {
        state.LoadingCases = true;
      })
      .addCase(getCases.fulfilled, (state, action) => {
        state.Cases = action.payload;
        state.LoadingCases = false;
      })
      .addCase(getCases.rejected, (state) => {
        state.LoadingCases = false;
      })
      .addCase(getCasesTableColumnOrder.fulfilled, (state, action) => {
        state.SavedColumnOrder = action.payload;
      });
  },
});

export const getCases = createAsyncThunk("cases/GetCases", async (meetingID: number | undefined) => {
  const caseService = container.get<ICasesService>(SERVICE_TYPES.CasesService);
  return await caseService.getCases(meetingID);
});

export const getCasesTableColumnOrder = createAsyncThunk("cases/GetCasesTableColumnOrder", async () => {
  const userSettingsService = container.get<IUserSettingsService>(SERVICE_TYPES.UserSettingsService);
  return await userSettingsService.getColumnOrder(SETTING_TYPES.CaseTableColumnKey);
});

export const updateCasesTasksTableColumnOrder = createAsyncThunk(
  "cases/UpdateCasesTableColumnOrder",
  async (tableColumnOrder: string[]) => {
    const userSettingsService = container.get<IUserSettingsService>(SERVICE_TYPES.UserSettingsService);
    await userSettingsService.setColumnOrder(tableColumnOrder, SETTING_TYPES.CaseTableColumnKey);
  }
);

export const { setCaseTypeID, setCaseStatusTypeID, setSLAType } = casesTableSlice.actions;

export const selectCases = (state: RootState) => state.cases.Cases;
export const selectLoadingCases = (state: RootState) => state.cases.LoadingCases;
export const selectCaseTypeID = (state: RootState) => state.cases.CaseTypeID;
export const selectCaseStatusTypeID = (state: RootState) => state.cases.CaseStatusTypeID;
export const selectSLAType = (state: RootState) => state.cases.SLAType;
export const selectSavedColumnOrder = (state: RootState) => state.cases.SavedColumnOrder;

export default casesTableSlice.reducer;
